import React from 'react';
import { Star, Radio, ArrowRight, Plus } from 'lucide-react';
import { TEMPLATE_ICONS } from './shared';

export function TemplateGrid({ templates, onSelect }) {
  // Separate "Crea nuovo" (custom) from approved templates so it stands out
  const custom = templates.find(t => t.id === 'custom');
  const approved = templates.filter(t => t.id !== 'custom');

  return (
    <div data-testid="template-grid">
      <div className="flex items-center gap-2 mb-4">
        <Radio size={15} className="text-[#D44E20]" />
        <h2 className="font-semibold text-[#1A1A1A] text-sm">Scegli un template</h2>
      </div>

      {/* Custom / Crea nuovo - highlighted card on top */}
      {custom && (
        <button
          onClick={() => onSelect(custom)}
          data-testid="template-custom"
          className="w-full mb-3 bg-gradient-to-br from-[#D44E20] to-[#B83D15] rounded-2xl p-4 shadow-sm text-left text-white hover:shadow-md transition-all group"
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center flex-shrink-0">
              <Plus size={18} className="text-white" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-sm">{custom.name}</p>
              <p className="text-white/80 text-xs mt-0.5">{custom.description}</p>
            </div>
            <ArrowRight size={14} className="text-white/80 group-hover:translate-x-0.5 transition-transform flex-shrink-0" />
          </div>
        </button>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {approved.map(t => {
          const Icon = TEMPLATE_ICONS[t.icon] || Star;
          return (
            <button
              key={t.id}
              onClick={() => onSelect(t)}
              data-testid={`template-${t.id}`}
              className="bg-white rounded-2xl border border-slate-100 p-4 shadow-sm text-left hover:border-[#D44E20]/40 hover:shadow-md transition-all group"
            >
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-xl bg-[#D44E20]/8 flex items-center justify-center flex-shrink-0 group-hover:bg-[#D44E20]/15 transition-colors">
                  <Icon size={16} className="text-[#D44E20]" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <p className="font-semibold text-[#1A1A1A] text-sm">{t.name}</p>
                    <ArrowRight size={13} className="text-[#ccc] group-hover:text-[#D44E20] transition-colors flex-shrink-0 ml-2" />
                  </div>
                  <p className="text-[#999] text-xs mt-0.5 line-clamp-2">{t.description}</p>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
